import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import {
  UxAvatar,
  UxAvatarPriorityEnum,
  UxAvatarEnum,
  UxIcon,
  UxIconEnum,
  UxToast,
  UxSizeExtendedEnum,
  UxIconLibraryEnum
} from "@imaginelearning/mps-ux-component-library";
import "./edge-activity-complete-toast.scss";
import { UserContext } from "context-providers/user.provider";
import { IUser } from "@imaginelearning/mps-api-service";
import defaultConfig from "config";
import useGradeRange from "hooks/usegraderange";
import useTheme from "../../hooks/usetheme";

interface IActivityCompleteToastProps {
  show: boolean;
  starsEarned: number;
  message: string;
  handleClose: () => void;
}

function ActivityCompleteToast(props: IActivityCompleteToastProps) {
  const { show, starsEarned, message, handleClose } = props;
  const config = defaultConfig();
  const { t } = useTranslation();
  const { userState } = useContext(UserContext);
  const { theme } = useTheme();
  const { is9to12 } = useGradeRange();
  const user: IUser = userState.response as IUser;
  const selectedAvatar: UxAvatarEnum =
    user.avatar == null ? config.defaults.avatar : (UxAvatarEnum as any)[user.avatar.toUpperCase()];

  return (
    <UxToast
      className={`activity-complete-toast ${theme}`}
      show={show}
      dismissible={false}
      delay={4000}
      handleClose={handleClose}
      hideBorders={true}
      header={null}
      body={
        <Row className="activity-complete-toast-body">
          {!is9to12 && (
            <Col className="activity-complete-toast-avatar-wrapper d-flex">
              <UxAvatar
                className="activity-complete-toast-avatar"
                avatar={selectedAvatar}
                avatarType={UxAvatarPriorityEnum.DEFAULT}
                size={UxSizeExtendedEnum.X4}
                theme={theme}
              />
            </Col>
          )}
          <Col className="activity-complete-toast-message-wrapper d-flex">
            {is9to12 && (
              <UxIcon icon={UxIconEnum.CHECK_CIRCLE} size={UxSizeExtendedEnum.X3} library={UxIconLibraryEnum.SOLID} />
            )}
            <div className="activity-complete-toast-message text-center">
              <div className="toast-message">
                <h2>{t(message)}</h2>
              </div>
            </div>
            {!is9to12 && (
              <div className="activity-complete-toast-star-earned d-flex align-items-center justify-content-center">
                <div className="star-earned">
                  <UxIcon icon={UxIconEnum.STAR} size={UxSizeExtendedEnum.X2} className="pb-3 ps-2" alt="Star" />x
                  {starsEarned}
                </div>
              </div>
            )}
          </Col>
        </Row>
      }
    />
  );
}

export default ActivityCompleteToast;
